import colors, { withOpacity } from '../../utils/colors';

import { InputColors } from './types';

export const INPUT_HEIGHT = 46;
export const INPUT_MULTILINE_HEIGHT = 80;
export const INPUT_BORDER_WIDTH = 3;
export const INPUT_PADDING_HORIZONTAL = 15;
export const INPUT_MARGIN_BOTTOM = 15;

type GetInputsColors = (params: {
  error?: string | boolean;
  hasValue: boolean;
  isFocused: boolean;
  variant?: 'default' | 'transparent';
}) => InputColors;

export const getInputColors: GetInputsColors = ({ error, hasValue, isFocused, variant = 'default' }) => {
  const defaultColors: InputColors = {
    background: variant === 'transparent' ? 'transparent' : colors.ink10,
    border: variant === 'transparent' ? withOpacity(colors.white100, 0.5) : colors.ink10,
    icon: colors.ink100,
    placeholder: variant === 'transparent' ? colors.ink100 : withOpacity(colors.ink100, 0.7),
    textColor: variant === 'transparent' ? colors.ink120 : colors.ink100,
  };

  const inputColors = defaultColors;

  if (hasValue) {
    inputColors.placeholder = variant === 'transparent' ? colors.ink100 : colors.ink50;
  }

  if (error) {
    inputColors.background = colors.white100;
    inputColors.border = colors.error100;
    inputColors.icon = colors.error100;
    inputColors.placeholder = colors.error100;
  }

  if (isFocused) {
    inputColors.background = colors.white100;
    inputColors.border = 'gradient';
    inputColors.icon = colors.ink100;
    inputColors.placeholder = colors.primary100;
  }

  return inputColors;
};
